import React from "react";
import { Card, Group, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useCellRender } from "../hooks/useCellRender";
import EntityTabAnchor from "../pages/account/payroll2/EntityTabAnchor";

const CommissionStatementBankTransaction = ({ form }) => {
  const { t } = useTranslation();
  const [cellRender] = useCellRender();
  const bankTransactionCode = form?.values?.bankTransactionCode;
  const bankTransactionId = form?.values?.bankTransaction;

  if (!bankTransactionId && !bankTransactionCode) {
    return null;
  }

  return (
    <Card withBorder mb="md">
      <Text size="sm" weight={600} mb="sm">
        {t("commissionStatement.linkedBankTransaction.title")}
      </Text>
      <Stack spacing="xs">
        <Group position="apart">
          <Text size="xs" color="dimmed">
            {t("commissionStatement.linkedBankTransaction.code")}
          </Text>
          <EntityTabAnchor
            entity="bankTransaction"
            id={bankTransactionId}
            label={bankTransactionCode}
            size="sm"
          />
        </Group>
        <Group position="apart">
          <Text size="xs" color="dimmed">
            {t("bankTransaction.linkCommissionStatement.netDeposit")}
          </Text>
          <Text size="xs">
            {cellRender.Currency(form.values.receivedNetAmount ?? 0)}
          </Text>
        </Group>
        <Group position="apart">
          <Text size="xs" color="dimmed">
            {t("bankTransaction.bankCharge")}
          </Text>
          <Text size="xs">
            {cellRender.Currency(form.values.bankCharge ?? 0)}
          </Text>
        </Group>
        <Group position="apart">
          <Text size="xs" color="dimmed">
            {t("bankTransaction.linkCommissionStatement.grossAmount")}
          </Text>
          <Text size="xs" weight={600}>
            {cellRender.Currency(form.values.receivedGrossAmount ?? 0)}
          </Text>
        </Group>
      </Stack>
    </Card>
  );
};

export default CommissionStatementBankTransaction;
